import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { ISectionFormField } from '@interfaces/section-form-field';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { isObject, isUndefined } from 'lodash-es';

@Component({
  selector: 'app-section-form-block-layout',
  templateUrl: './section-form-block-layout.component.html',
  styleUrls: ['./section-form-block-layout.component.scss'],
})
export class SectionFormBlockLayoutComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public headerTitle: string = '';
  @Input() public headerTitleClass: string = '';
  @Input() public sectionClass: string = '';
  @Input() public editBlockDescription: string = '';
  @Input() public infoTooltip: string = '';
  @Input() public fields: ISectionFormField[] = [];
  @Input() public displayFields: ISectionFormField[] = [];
  @Input() public displayErrors: Map<string, string> = new Map<string, string>();
  @Input() public formErrors: { [name: string]: IErrorForm };
  @Input() public editBlockClass: string = '';
  @Input() public isEditBlockOpenByDefault: boolean;
  @Input() public isShowEditButton: boolean = true;
  @Input() public isShowEditBlockLabel: boolean = true;
  @Input() public isHideBorder: boolean = false;
  @Input() public isHeaderTitleUpperCase: boolean = false;
  @Input() public isInvalid: boolean = false;

  @Output() public edit: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isShowEditBlock: boolean = false;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;

  ngOnInit(): void {
    if (this.isEditBlockOpenByDefault) {
      this.isShowEditBlock = true;
    }
  }

  public get titleClasses(): string {
    const errorClass = this.isInvalid && !this.isShowEditBlock ? ' text-error' : '';
    return `app-section-block-layout__section__header__title ${this.headerTitleClass}${errorClass}`;
  }

  public onEdit() {
    this.isShowEditBlock = !this.isShowEditBlock;
    this.edit.emit(this.isShowEditBlock);
  }

  public getFormFieldValue(field: ISectionFormField) {
    const formValue = this.formGroup?.get(field?.fgName || field.name)?.value;
    const isFormValueObject = isObject(formValue);
    return field?.value || (isFormValueObject ? '' : formValue);
  }

  public formFieldError(fieldName): string {
    return this.displayErrors.get(fieldName) || '';
  }

  public fieldsCombinedText(item: any, fieldNames: string[]) {
    let combinedText: string = '';
    fieldNames.forEach((fn) => {
      combinedText += item[fn] + ' ';
    });
    return combinedText;
  }

  public isNotANumber(value) {
    return isNaN(value);
  }

  public isNumericInputModeeField(field: ISectionFormField): boolean {
    const numericFieldTypes: string[] = ['decimal', 'number', 'numeric'];

    return !!field?.inputMode ? !!numericFieldTypes.includes(field?.inputMode) : false;
  }

  public fieldHelper(field: ISectionFormField): string {
    if (isUndefined(field?.isShowHelper)) {
      return field?.helper;
    } else {
      return field?.isShowHelper ? field?.helper : '';
    }
  }

  public isNgSelect(field: ISectionFormField): boolean {
    return !!field?.labelTemplateFieldNames || !!field?.optionTemplateFieldNames || field?.isNgSelect;
  }

  public get visibleFields(): ISectionFormField[] {
    return this.fields.filter((field) => !field.isHidden);
  }

  public get visibleDisplayFields(): ISectionFormField[] {
    return !!this.displayFields && this.displayFields.length > 0
      ? this.displayFields.filter((field) => !field.isHidden)
      : this.visibleFields;
  }
}
